module.exports = __webpack_public_path__ + "static/media/secondTopicAc.adec4e60.svg";